import React, { useState } from 'react';
import ModalDialog from '../ModalDialog';
import DialogueLayerIcon from '../../icons/DialogueLayerIcon';
import MusicLayerIcon from '../../icons/MusicLayerIcon';
import SfxLayerIcon from '../../icons/SfxLayerIcon';
import BassIcon from '../../icons/BassIcon';
import DrumsIcon from '../../icons/DrumsIcon';
import GuitarIcon from '../../icons/GuitarIcon';
import OtherInstrumentIcon from '../../icons/OtherInstrumentIcon';
import PercussionIcon from '../../icons/PercussionIcon';
import StringsIcon from '../../icons/StringsIcon';
import WoodwindIcon from '../../icons/WoodwindIcon';
import PianoIcon from '../../icons/PianoIcon';
import MagicAiIcon from '../../icons/MagicAiIcon';
import '../../assets/components/ModalStemSplitter.css';

const STUDIO_TYPES = [
    { id: 'dialogue', label: 'Dialogue', Icon: DialogueLayerIcon },
    { id: 'music',    label: 'Music',    Icon: MusicLayerIcon },
    { id: 'sfx',      label: 'SFX',      Icon: SfxLayerIcon },
];

const REC_TYPES = [
    { id: 'bass',       label: 'Bass',       Icon: BassIcon },
    { id: 'drums',      label: 'Drums',      Icon: DrumsIcon },
    { id: 'guitar',     label: 'Guitar',     Icon: GuitarIcon },
    { id: 'percussion', label: 'Percussion', Icon: PercussionIcon },
    { id: 'piano',      label: 'Piano',      Icon: PianoIcon },
    { id: 'strings',    label: 'Strings',    Icon: StringsIcon },
    { id: 'woodwind',   label: 'Woodwind',   Icon: WoodwindIcon },
    { id: 'other',      label: 'Other',      Icon: OtherInstrumentIcon },
];

const ModalStemSplitter = ({ visible, selection, onHide, onSubmit, title = 'Stem Splitter' }) => {
    const [selectedTypes, setSelectedTypes] = useState([]);
    const [note, setNote] = useState('');
    const [generating, setGenerating] = useState(false);

    const types = selection?.timelineType === 'rec' ? REC_TYPES : STUDIO_TYPES;

    const toggleType = (id) => {
        setSelectedTypes(prev =>
            prev.includes(id) ? prev.filter(t => t !== id) : [...prev, id]
        );
    };

    const handleHide = () => {
        setGenerating(false);
        setSelectedTypes([]);
        setNote('');
        onHide();
    };

    const handleSubmit = () => {
        if (!selectedTypes.length || generating) return;
        setGenerating(true);
        setTimeout(() => {
            onSubmit({ ...selection, types: selectedTypes, note });
            setGenerating(false);
            setSelectedTypes([]);
            setNote('');
        }, 3000);
    };

    return (
        <ModalDialog
            header={title}
            visible={visible}
            onHide={handleHide}
            onSubmit={handleSubmit}
            width={480}>
            <div className="stemSplitterModal">
                <div className={`stemSplitterModal__types ${selection?.timelineType === 'rec' ? 'twoCols' : 'onCol'}`}>
                    {types.map(({ id, label, Icon }) => (
                        <label
                            key={id}
                            className={`appButton__3d stemSplitterModal__typeBtn${selectedTypes.includes(id) ? ' stemSplitterModal__typeBtn--selected' : ''}`}>
                            <input
                                type="checkbox"
                                checked={selectedTypes.includes(id)}
                                onChange={() => toggleType(id)}
                            />
                            <span>
                                <Icon/>
                                {label}
                            </span>
                        </label>
                    ))}
                </div>
                <textarea
                    className="stemSplitterModal__note"
                    placeholder="Add a note..."
                    value={note}
                    onChange={e => setNote(e.target.value)}
                    rows={3}
                />
                <div className="stemSplitterModal__actions">
                    <button
                        className="stemSplitterModal__submit"
                        disabled={!selectedTypes.length || generating}
                        onClick={handleSubmit}>
                        <MagicAiIcon/>
                        Generate
                    </button>
                    {generating && <div className="stemSplitterModal__progress" />}
                </div>
            </div>
        </ModalDialog>
    );
};

export default ModalStemSplitter;
